<template>
  <v-autocomplete
    :items="optionEntityListFormatted"
    :loading="loading"
    :rules="[validateHasValue]"
    :value="value"
    @input="value => $emit('input', value)"
    clearable
    outlined
    required
  ></v-autocomplete>
</template>

<script>
import selectFkMixin from "./selectFkMixin";

export default {
  mixins: [selectFkMixin],
};
</script>
